'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

var _Details = require('../Details');

var _Details2 = _interopRequireDefault(_Details);

var _Distance = require('../Distance');

var _Distance2 = _interopRequireDefault(_Distance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var detailStyle = function detailStyle(location) {
  return location.selected ? '' : 'detailHide';
};

var summaryStyle = function summaryStyle(location) {
  return location.selected ? 'summaryHide' : 'summary';
};

var renderList = function renderList(props) {
  var listItems = props.locations.map(function (location) {
    return _react2.default.createElement(
      'li',
      {
        styleName: 'location',
        onClick: function onClick() {
          return props.selectLocation(location.id);
        },
        key: location.id
      },
      _react2.default.createElement(
        'div',
        { styleName: summaryStyle(location) },
        _react2.default.createElement(
          'div',
          { styleName: 'text' },
          _react2.default.createElement(
            'header',
            { styleName: 'header' },
            location.name
          ),
          _react2.default.createElement(
            'p',
            { styleName: 'address' },
            location.address,
            ', ',
            location.postcode
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'distance' },
          _react2.default.createElement(_Distance2.default, { distance: location.distance_in_miles })
        )
      ),
      _react2.default.createElement(
        'div',
        { styleName: detailStyle(location) },
        _react2.default.createElement(_Details2.default, {
          details: location,
          confirm: props.confirm,
          close: props.close
        })
      )
    );
  });

  return _react2.default.createElement(
    'ul',
    { styleName: 'list' },
    listItems
  );
};

var PickupLocatorList = function PickupLocatorList(props) {
  if (props.fetching === true) {
    return _react2.default.createElement(
      'p',
      { styleName: 'none' },
      'Loading...'
    );
  }

  if (props.locations && props.locations.length === 0) {
    return _react2.default.createElement(
      'p',
      { styleName: 'none' },
      'No results'
    );
  }

  return renderList(props);
};

PickupLocatorList.propTypes = {
  fetching: _react.PropTypes.bool,
  locations: _react.PropTypes.arrayOf(_react.PropTypes.shape({
    id: _react.PropTypes.number.isRequired,
    name: _react.PropTypes.string.isRequired,
    address: _react.PropTypes.string.isRequired,
    distance_in_miles: _react.PropTypes.string.isRequired
  })),
  selectLocation: _react.PropTypes.func.isRequired
};

exports.default = (0, _reactCssModules2.default)(PickupLocatorList, _style2.default);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/PickupLocator/List/index.js
// module id = 550
// module chunks = 0